import React, { useEffect, useState } from 'react';
import { useStateValue } from "../GlobalState/StateProvider";
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { DataView } from "primereact/dataview";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { Toast } from 'primereact/toast';
import axios from "axios";
import './Dashboard.css';

function BraintreeSubscription({ SubsID, setBraintreeStatus }) {
  
    const navigate = useNavigate();
    const [{ user}, dispatch] = useStateValue();
    const [data, setData] = useState(null);
    const [type, setType] = useState(null);
    const [isRetrying, setIsRetrying] = useState(false);
    const toast = React.useRef();

   
  
    useEffect(() => {
        
       
    }, [])

    
   
    useEffect(() => {
        if (typeof SubsID !== 'undefined') {
           callBraintreeSubscription() 
        }
    }, [SubsID])

   
  
    const callBraintreeSubscription = () => {
        var subscriptionId = SubsID;
        const url = `api/braintree/subscription/${subscriptionId}`;

        const params = {

            "subscriptionId": subscriptionId
        }

        var endpoint = location.origin + '/' + url;
        axios.get(endpoint, params)

            .then(function (response) {
                //handle success
                if (response.status === 200) {

                    setData(response.data.data);
                    setType(response.data.type);
                    setBraintreeStatus(response.data.data.Status === 'ACTIVE' ? true:false);

                }

            })
            .catch(function (response) {
                //handle error
                alert(response);
                console.log(response);
            });
    }

    const getStatusBadgeClass = (status) => {
        switch (status?.toLowerCase()) {
            case 'submitted_for_settlement':
            case 'settled':
                return 'bg-success';
            case 'authorized':
                return 'bg-info';
            case 'failed':
            case 'gateway_rejected':
            case 'processor_declined':
                return 'bg-danger';
            case 'settlement_declined':
                return 'bg-warning';
            case 'settlement_pending':
                return 'bg-primary';
            default:
                return 'bg-secondary';
        }
    };

    const handleRetryPayment = async () => {
        try {
            setIsRetrying(true);
           
            const response = await axios.post(`${location.origin}/api/braintree/subscription/retry`, {
                subscriptionId: SubsID
            });

            if (response.data.status === 'success') {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response.data.message,
                    life: 3000
                });
                // Refresh subscription data
                callBraintreeSubscription();
            }
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: error.response?.data?.message || 'Failed to retry payment',
                life: 3000
            });
        } finally {
            setIsRetrying(false);
        }
    };

    return (
        <div className="mt-2">
            <Toast ref={toast} />
            <div className="mt-0">
             
                <div className="card shadow-lg">
                    {data && (
                        <div className="card-body">
                            <h5>Braintree Subscription Info</h5>
                            {type === 'subscription' ? (
                                <>
                                    <p><strong>Subscription ID:</strong> {data.Id}  |  <strong>Plan ID:</strong> {data.PlanId || 'N/A'}  |  <strong>Customer Name:</strong> {data.Transactions[0].CustomerDetails && `${data.Transactions[0].CustomerDetails.FirstName} ${data.Transactions[0].CustomerDetails.LastName}`} | <strong>Email:</strong> {data.Transactions[0].CustomerDetails && data.Transactions[0].CustomerDetails.Email}</p>
                                    <p>
                                        <strong>Status:</strong> {data.Status} | <strong>Price:</strong> ${data.Price}
                                        {data.Status === 'PAST_DUE' && (
                                            <Button 
                                                label="Retry Payment" 
                                                className="p-button-warning ml-3" 
                                                loading={isRetrying}
                                                onClick={handleRetryPayment}
                                            />
                                        )}
                                    </p>
                                    <p><strong>Billing Period Start Date:</strong> {data.BillingPeriodStartDate ? new Date(data.BillingPeriodStartDate).toISOString().slice(0, 10) : 'N/A'} | <strong>Billing Period End Date:</strong> {data.BillingPeriodEndDate ? new Date(data.BillingPeriodEndDate).toISOString().slice(0, 10) : 'N/A'} | <strong>Next Billing Date:</strong> {data.NextBillingDate ? new Date(data.NextBillingDate).toISOString().slice(0, 10) : 'N/A'}</p>
                                                                
                                    <h6>Transaction Details</h6>
                                    {data.Transactions && data.Transactions.length > 0 && (
                                        <div>
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Transaction ID</th>
                                                        <th>Amount</th>
                                                        <th>Payment Method</th>
                                                        <th>Status</th>
                                                        <th>Transaction Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.Transactions.map((transaction, index) => (
                                                        <tr key={index}>
                                                            <td>{transaction.Id}</td>
                                                            <td>${transaction.Amount}</td>
                                                            <td>{transaction.PaymentInstrumentType}</td>
                                                            <td>
                                                                <span className={`badge ${getStatusBadgeClass(transaction.Status)}`}>
                                                                    {transaction.Status || 'Unknown'}
                                                                </span>
                                                            </td>
                                                            <td>{transaction.CreatedAt ? new Date(transaction.CreatedAt).toLocaleString() : 'N/A'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                        <p><strong>Transaction ID:</strong> {data.Id}</p>
                                        <p><strong>Plan ID:</strong> {data.PlanId || 'N/A'}</p>
                                        <p><strong>Customer Name:</strong> {data.CustomerDetails && `${data.CustomerDetails.FirstName} ${data.CustomerDetails.LastName}`}</p>
                                        <p><strong>Email:</strong> {data.CustomerDetails && data.CustomerDetails.Email}</p>
                                        <p><strong>Payment Method:</strong> {data.PaymentMethod && data.PaymentMethod.Type}</p>
                                        <p><strong>Amount:</strong> ${data.Amount}</p>
                                        <p><strong>Status:</strong> {data.Status}</p>
                                        <p><strong>Transaction Date:</strong> {data.CreatedAt ? new Date(data.CreatedAt).toLocaleString() : 'N/A'}</p>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

}
export default BraintreeSubscription;